/**
 * Hanko Menu – Core TypeScript interfaces and types
 */

// ─── Supported Locales ───────────────────────────────────────────────────────

export const SUPPORTED_LOCALES = ['en', 'ja'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

// ─── Internationalization ────────────────────────────────────────────────────

export interface LocaleBundle {
  loading: string;
  'cart.subtotal': string;
  'cart.shipping': string;
  'cart.tax': string;
  'cart.orderTotal': string;
  'cart.shippingTaxFooter': string;
  'cart.yourCart': string;
  'cart.emptyMessage': string;
  'cart.viewCart': string;
  'cart.emptyCart': string;
  'cart.emptying': string;
  'cart.confirmEmptyMessage': string;
  'dialog.confirm': string;
  'dialog.cancel': string;
  'cart.ariaShoppingCart': string;
  'cart.ariaCartItems': string;
  'menu.ariaUserMenu': string;
  'product.quantity': string;
  'fallback.signInPrompt': string;
  'fallback.logIn': string;
  'fallback.createId': string;
}

// ─── Hook Return Types ───────────────────────────────────────────────────────

export interface UseI18nReturn {
  t: (key: string) => string;
  isLoading: boolean;
  currentLocale: string;
}

export interface EnvironmentConfig {
  appTarget: string;
  loginApiUrl: string;
  bffApiUrl: string;
  registerApiUrl: string;
  accountApiUrl: string;
  cartUrl: string;
  signInUrl: string;
  pollIntervalMs: number;
}

export * from './bff';
